import { render, staticRenderFns } from "./AbrirCaixa.vue?vue&type=template&id=6a785f6b"
import script from "./AbrirCaixa.vue?vue&type=script&lang=js"
export * from "./AbrirCaixa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports